// extracted by mini-css-extract-plugin
module.exports = {"text":"bodyCopySkins-medium-text-512f7bac"};